import { render, staticRenderFns } from "./ProductSupport.vue?vue&type=template&id=744908a9&scoped=true&"
import script from "./ProductSupport.vue?vue&type=script&lang=js&"
export * from "./ProductSupport.vue?vue&type=script&lang=js&"
import style0 from "./ProductSupport.vue?vue&type=style&index=0&id=744908a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744908a9",
  null
  
)

export default component.exports